export const unescapeHTML = (escapedHTML: string) => {
  const element = document.createElement('div');
  element.innerHTML = escapedHTML;

  return element.textContent as string;
};
